import * as React from 'react';

import * as Cookie from 'js-cookie';

import {
  breakpoints,
  Tooltip,
  TooltipModel,
  Colors,
} from '@notino/react-styleguide';

import PriceLabel from '@components/PriceLabel';
import { useIsDualPriceForCroatia } from '@containers/ProductDetailContainer/ProductDetail/hooks/useIsDualPriceForCroatia';
import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';
import { usePriceLogic } from '@containers/ProductDetailContainer/ProductDetail/hooks/usePriceLogic';
import { variantFragment } from '@containers/ProductDetailContainer/queries/__generated__/variantFragment';

import {
  DiscountWrapper,
  OriginalPriceWrapper,
  StyledInfoIcon,
  LineThrough,
  Discount,
  PriceWrapper,
  CurrencyWrapper,
  Slash,
  FlexEnd,
} from './styled';

const NO_RESP = 'noresp';

interface IProps {
  variant: variantFragment;
}

export const OriginalPrice = ({ variant }: IProps) => {
  // need topLeft position for desktop version on mobile
  const [tooltipProps, setTooltipProps] = React.useState({});
  const {
    isDualPriceForCroatia,
    leftSideCurrency,
    rightSideCurrency,
    getLeftSideFormattedPrice,
    getRightSidePrice,
  } = useIsDualPriceForCroatia();
  const { discountText, topPrice } = usePriceLogic(variant);
  const newDesign = useNewPdDesignEnabled();

  React.useEffect(() => {
    if (Number(Cookie.get(NO_RESP))) {
      setTooltipProps({
        position: TooltipModel.Position.topLeft,
        alignDesktop: true,
      });
    }
  }, []);

  if (!topPrice) {
    return null;
  }

  return (
    <DiscountWrapper data-testid="originalPriceDiscountWrapper">
      <OriginalPriceWrapper newDesign={newDesign}>
        {isDualPriceForCroatia && (
          <>
            <LineThrough
              active={topPrice.isCrossed}
              data-testid="originalDualPriceLineThroughWrapper"
            >
              <PriceWrapper>
                {getLeftSideFormattedPrice(topPrice.value.value)}{' '}
                {leftSideCurrency}
              </PriceWrapper>
            </LineThrough>
            <Slash>/</Slash>
          </>
        )}

        <FlexEnd>
          <LineThrough
            active={topPrice.isCrossed}
            data-testid="originalPriceLineThroughWrapper"
          >
            <PriceLabel
              price={
                isDualPriceForCroatia
                  ? {
                      value: getRightSidePrice(topPrice.value.value),
                    }
                  : topPrice.value
              }
              currencySymbolOverride={
                isDualPriceForCroatia ? rightSideCurrency : undefined
              }
              wrapperComponent={PriceWrapper}
              currencyComponent={CurrencyWrapper}
            />
          </LineThrough>

          <Tooltip
            {...tooltipProps}
            interactive={true}
            breakpointToCenter={breakpoints.xl}
            content={topPrice.tooltip}
          >
            <StyledInfoIcon color={Colors.neutral} height="0.9em" />
          </Tooltip>
        </FlexEnd>
      </OriginalPriceWrapper>

      <Discount newDesign={newDesign}>{discountText}</Discount>
    </DiscountWrapper>
  );
};
